import { clean } from "../utils/utils";
import api from "./api";
import { HolidaySchedule } from "../models/HolidaySchedule";

const PATH = "/api/v1/holiday-schedules";

export const HolidayScheduleService = {
  async create(
    file: globalThis.File | null,
    data: Omit<HolidaySchedule, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const formData = new FormData();
    if (file) formData.append("file", file);
    formData.append("name", data.name);
    formData.append("matterId", data.matterId!);
    const res = await api.post(`${PATH}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data.data._id;
  },

  async getAll(): Promise<HolidaySchedule[]> {
    const response = await api.get(PATH);
    return response.data.data;
  },

  async get(id: string): Promise<HolidaySchedule> {
    const response = await api.get(`${PATH}/${id}`);
    return response.data.data;
  },

  async update(
    id: string,
    updates: Partial<Omit<HolidaySchedule, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.patch(`${PATH}/${id}`, clean(updates));
  },

  async delete(id: string): Promise<void> {
    await api.delete(`${PATH}/${id}`);
  },

  async getDownloadURL(id: string): Promise<string> {
    const response = await api.get(`${PATH}/${id}/download`);
    return response.data.data.url;
  },

  async uploadFile(id: string, file: globalThis.File): Promise<string> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await api.put(`${PATH}/${id}/file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data.data._id;
  },
};
